import { render, staticRenderFns } from "./EditTextPanel.vue?vue&type=template&id=653411da&scoped=true&"
import script from "./EditTextPanel.vue?vue&type=script&lang=js&"
export * from "./EditTextPanel.vue?vue&type=script&lang=js&"
import style0 from "./EditTextPanel.vue?vue&type=style&index=0&id=653411da&scoped=true&lang=css&"
import style1 from "./EditTextPanel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653411da",
  null
  
)

export default component.exports